import styled from 'styled-components'
import theme from '../theme'

export default styled.footer`
  margin-top: 3rem;
  text-align: center;
  font-size: 0.6rem;
  text-transform: uppercase;
  padding: 0.2rem;
  border-top: 1px solid ${theme.backgroundOff};
`;
